/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import _ from 'lodash';
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdminResourceItemRoutePageComponent} from '../../common/controller/admin-resource-item-route-page.component';
import {AdminResourceContextRoutePageComponent} from '../../common/controller/admin-resource-context-route-page.component';
import {getRoutePageComponent, getContextRoutePageComponent} from '../../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import {adminResourceItemRouteResolve} from '../../common/controller/admin-resource-routing';
import {LayoutIncludeCopyModalComponent} from './layout-include-copy-modal.component';
import {LayoutResource} from '../../../components/api/resources/resource/layout.resource';
import {LayoutIncludeResource} from '../../../components/api/resources/resource/layout-include.resource';
import {PERMISSIONS} from '../../../components/auth/auth-constants';


export function layoutIncludeStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterAndChildHelper('layout-includes.layout-include', LayoutIncludeResource, LayoutResource, 'app.adm', 'app/admin');
    
        $stateProvider.state(rh.listPath(), rh.list({
          views: {
            'content@app': { component: getRoutePageComponent('layout-include-route') }
          },
          resolve: {
            readOnly: /*@ngInject*/ function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasNetwork(PERMISSIONS.manageLayouts.apiKey);
            }
          }
        }));
    
        $stateProvider.state(rh.newItemPath(), rh.newItem());
    
        $stateProvider.state(rh.itemPath(), rh.modelCommsItem({
          resolve: _.merge({}, adminResourceItemRouteResolve('layout-include-edit', 'edit'), {
            copyConfig: function() {
              return {
                modalComponent: LayoutIncludeCopyModalComponent,
                stateUrl: 'app.adm.layout-includes.layout-include',
                lcase: 'layout include',
                ucase: 'Layout Include'
              };
            }
          }),
            views: {
            'content@app': { component: AdminResourceItemRoutePageComponent, bindings: { item: 'adminResourceItemKey', variant: 'adminResourceItemVariant' }  },
            'context@app': {component: AdminResourceContextRoutePageComponent}
          }
        }, 'LayoutInclude'));
  }, adnRouterHelper);
}
